/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const pluginPostbackSetRefundStatusOrderStatusEnumSchema = z
	.enum(["refunded", "refund_failed"])
	.describe("* `refunded` - refunded\n* `refund_failed` - refund_failed");
